import React, { useEffect, useState } from 'react';
import { FaHistory, FaUser, FaInfoCircle } from 'react-icons/fa';
import { toast } from 'react-toastify';
import logService from '../services/logService';

const LogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const data = await logService.getAll();
        setLogs(data);
      } catch (error) {
        console.error('Loglar yüklenemedi');
        toast.error('Log kayıtları yüklenemedi. (Sunucu bağlantısını kontrol edin)');
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
  }, []);

  const filteredLogs = logs.filter(log => {
    const matchesSearch = (log.user_name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (log.action || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (log.entity || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (log.details || '').toLowerCase().includes(searchTerm.toLowerCase());

    if (!matchesSearch) return false;

    const logDate = new Date(log.created_at);
    
    if (startDate) {
      const start = new Date(startDate);
      if (logDate < start) return false;
    }

    if (endDate) {
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999); // Günün sonuna kadar
      if (logDate > end) return false;
    }

    return true;
  });

  if (loading) return <div className="text-center mt-5">Yükleniyor...</div>;

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2><FaHistory className="me-2" /> İşlem Geçmişi (Loglar)</h2>
      </div>

      <div className="card mb-3 shadow-sm bg-light">
        <div className="card-body py-3">
          <div className="row g-2">
            <div className="col-md-5">
              <input
                type="text"
                className="form-control"
                placeholder="Kullanıcı, işlem veya detay ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <input 
                type="date" 
                className="form-control" 
                value={startDate} 
                onChange={(e) => setStartDate(e.target.value)} 
                title="Başlangıç Tarihi"
              />
            </div>
            <div className="col-md-3">
              <input 
                type="date" 
                className="form-control" 
                value={endDate} 
                onChange={(e) => setEndDate(e.target.value)} 
                title="Bitiş Tarihi"
              />
            </div>
            <div className="col-md-1">
              <button 
                className="btn btn-outline-secondary w-100" 
                onClick={() => { setSearchTerm(''); setStartDate(''); setEndDate(''); }}
                title="Filtreleri Temizle"
              >
                Temizle
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover table-striped mb-0">
              <thead className="table-light">
                <tr>
                  <th>Tarih</th>
                  <th>Kullanıcı</th>
                  <th>İşlem</th>
                  <th>Kayıt Türü</th>
                  <th>Detaylar</th>
                </tr>
              </thead>
              <tbody>
                {filteredLogs.map((log) => (
                  <tr key={log.id}>
                    <td style={{width: '180px'}}>{new Date(log.created_at).toLocaleString('tr-TR')}</td>
                    <td className="fw-bold"><FaUser className="me-1 text-secondary" /> {log.user_name || 'Sistem'}</td>
                    <td>
                      <span className={`badge ${
                        log.action === 'Oluşturma' ? 'bg-success' :
                        log.action === 'Silme' ? 'bg-danger' :
                        log.action === 'Güncelleme' ? 'bg-primary' : 'bg-secondary'
                      }`}>
                        {log.action}
                      </span>
                    </td>
                    <td>{log.entity}</td>
                    <td className="text-muted small"><FaInfoCircle className="me-1" /> {log.details}</td>
                  </tr>
                ))}
                {filteredLogs.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center py-4 text-muted">Kayıt bulunamadı.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogsPage;
